import api from './api';

// --- Subjects ---

// Get All Subjects
export const getAllSubjects = async () => {
    try {
        const response = await api.get('/master/subjects');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Create Subject
export const createSubject = async (subjectData) => {
    try {
        const response = await api.post('/master/subjects', subjectData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Update Subject
export const updateSubject = async (id, subjectData) => {
    try {
        const response = await api.put(`/master/subjects/${id}`, subjectData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Delete Subject
export const deleteSubject = async (id) => {
    try {
        const response = await api.delete(`/master/subjects/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Streams ---

// Get All Streams
export const getAllStreams = async () => {
    try {
        const response = await api.get('/master/streams');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Create Stream
export const createStream = async (streamData) => {
    try {
        const response = await api.post('/master/streams', streamData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Update Stream
export const updateStream = async (id, streamData) => {
    try {
        const response = await api.put(`/master/streams/${id}`, streamData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Delete Stream
export const deleteStream = async (id) => {
    try {
        const response = await api.delete(`/master/streams/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};



// --- Specializations ---

// Get All Specializations
export const getAllSpecializations = async () => {
    try {
        const response = await api.get('/master/specializations');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Create Specialization
export const createSpecialization = async (specData) => {
    try {
        const response = await api.post('/master/specializations', specData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Update Specialization
export const updateSpecialization = async (id, specData) => {
    try {
        const response = await api.put(`/master/specializations/${id}`, specData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Delete Specialization
export const deleteSpecialization = async (id) => {
    try {
        const response = await api.delete(`/master/specializations/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Languages ---

// Get All Languages
export const getAllLanguages = async () => {
    try {
        const response = await api.get('/master/languages');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Create Language
export const createLanguage = async (langData) => {
    try {
        const response = await api.post('/master/languages', langData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Update Language
export const updateLanguage = async (id, langData) => {
    try {
        const response = await api.put(`/master/languages/${id}`, langData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Delete Language
export const deleteLanguage = async (id) => {
    try {
        const response = await api.delete(`/master/languages/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
// --- Universities and States ---

// Get All Universities
export const getAllUniversities = async () => {
    try {
        const response = await api.get('/universities/all');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Search Universities
export const searchUniversities = async (query) => {
    try {
        const response = await api.get(`/universities?search=${query}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Members (Reviewers, Editorial Board, Sub-EB) ---

// Get All Members (Reviewers, Editorial Board, Sub-EB)
export const getMembers = async () => {
    try {
        const response = await api.get('/members');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// --- Master Search (Department, Stream, Specialization) ---

// Get All Master Data
export const masterSearchAll = async () => {
    try {
        const response = await api.get('/master-search/all');
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

// Search Master Data
export const masterSearch = async (query) => {
    try {
        const response = await api.get(`/master-search?q=${query}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
